import React from 'react';

// #746, Session 79.22b.6.3 -- the Welding page's icon, for the menu and the
// bottom bar: a frame with a weld at its middle, as Grok drew it on the approved
// bar (docs/gates/drawings/2026-10-10_welding_746_amended_board_grok.html).
// Tabler has no frame-and-weld glyph. This takes Tabler's own props and its
// default stroke of 2, so it sits in the same maps as every other icon and
// matches its neighbours: the bars stay as Stede draws them (746 D25).
export default function WeldingIcon({ size = 24, stroke = 2, color = 'currentColor', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <rect x="3.5" y="6" width="17" height="12" rx="1.5" />
      <path d="M7 12h3.2M13.8 12H17" />
      <circle cx="12" cy="12" r="1.5" fill={color} stroke="none" />
    </svg>
  );
}
